import { Card, TableItem } from "components/atoms";
import ListWrapper from "components/molecules/list-wrapper/ListWrapper";
import { Table } from "components/organisms";
import { useScroll } from "components/templates/application/ApplicationTemplate";
import { useInfiniteTable } from "hooks/useInfiniteTable";
import { useCustomParamId, useParamId } from "hooks/useParamId";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useGetContractTracks } from "services/contract/products";

const ContractTracksTab = () => {
  // const contractId = useCustomParamId("contractId");
  const contractId = useParamId();

  const tracks = useGetContractTracks(contractId);

  const scroll = useScroll({ fetchNextPage: tracks.fetchNextPage });

  const tableProps = useInfiniteTable(tracks);

  const navigate = useNavigate();

  return (
    <ListWrapper
      items={tracks.data?.pages.flat()}
      isLoading={tracks.isLoading}
      isFetchingNextPage={tracks.isFetchingNextPage}
      item={(track) => (
        <Card
          key={track.id}
          header={track.mainTitle.title}
          description={track.isrc}
          onClick={() => navigate(`/track/${track.id}/data`)}
        />
      )}
    />
  );
};

export default ContractTracksTab;
